import { Route } from 'react-router-dom'
import { lazy } from 'react'

const AccountActivated = lazy(() => import('./pages/AccountActivated'))
const CodeConfirmation = lazy(() => import('./pages/CodeConfirmation'))
const CpfValidation = lazy(() => import('./pages/CpfValidation'))
const DependentData = lazy(() => import('./pages/DependentData'))
const SendValidation = lazy(() => import('./pages/SendValidation'))
const UserData = lazy(() => import('./pages/UserData'))

const ActivationRoutes = [
  <Route
    path="/ativacao/inicio"
    key="/ativacao/inicio"
    exact
    component={CpfValidation}
  />,
  <Route
    path="/ativacao/dados-usuario"
    key="/ativacao/dados-usuario"
    exact
    component={UserData}
  />,
  <Route
    path="/ativacao/dados-dependente/:dependentId"
    key="/ativacao/dados-dependente/:dependentId"
    exact
    component={DependentData}
  />,
  <Route
    path="/ativacao/enviar-codigo"
    key="/ativacao/enviar-codigo"
    exact
    component={SendValidation}
  />,
  <Route
    path="/ativacao/confirmar-codigo"
    key="/ativacao/confirmar-codigo"
    exact
    component={CodeConfirmation}
  />,
  <Route
    path="/ativacao/conta-ativada"
    key="/ativacao/conta-ativada"
    exact
    component={AccountActivated}
  />,
]

export default ActivationRoutes
